@if (collectionSize() > pageSize()) {
  <nav class="ds-pagination" [attr.aria-label]="ariaLabel()">
    <ngb-pagination
      class="ds-pagination__control"
      [collectionSize]="collectionSize()"
      [page]="page()"
      [pageSize]="pageSize()"
      [maxSize]="maxSize()"
      [rotate]="true"
      [ellipses]="true"
      [boundaryLinks]="false"
      (pageChange)="onPageChange($event)"
    >
      <ng-template ngbPaginationPrevious>
        <span class="ds-pagination__arrow" aria-hidden="true">←</span>
        <span class="visually-hidden">Previous page</span>
      </ng-template>

      <ng-template ngbPaginationNext>
        <span class="ds-pagination__arrow" aria-hidden="true">→</span>
        <span class="visually-hidden">Next page</span>
      </ng-template>
    </ngb-pagination>
  </nav>
}
